/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AppService } from '../api.service';
import { FormBuilder } from '@angular/forms';
import { ProjectsService } from './project.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CashbackService{
  displayAppointmentDialog=false;
  displayCashbackDialog=false;
  dealer: any;
  ref_by:any;
  invoice:any;
  payment_receipt:any;
  appointment_book_succuess_popup=false;
  displayBrandCashbackDetail=false;
  displayCatDetail=false;
  cbk_details:any={};
  invoice_url:any;
  file_type:any;
  file_type_payment!: string;
  file: any;
  registrationForm: any;
  is_uploading_progress!: boolean;
  uploadSuccess!: boolean;
  percentDone!: number;
  is_submit!: boolean;
  is_dealer_not_seleted!: boolean;
  is_invoice_receipt_not_upload!: boolean;
  professionl_phone:any;
  professionl_name:any;
  pro_name_required!: boolean;
submitted: any;
  is_professional_not_seleted!: boolean;
  is_dealers_loader!: boolean;
  dealers_list: any[]=[];
  isDesplayBrandStore=false;
  constructor(public _as:AppService,public fb: FormBuilder,public _project: ProjectsService,public router: Router,private _acRoute:ActivatedRoute) {
    this.registrationForm = this.fb.group({
      file: [null]
    }) 
   }

   getDealer(event?:any){
    const url = this._as.api_base_url + 'dealer/get/';
    const my_data = {
      city: event.city_id,
      brand: event.brand_id,
    }
    this.is_dealers_loader = true;
    this._as.postRequest(url,my_data, true).subscribe((res:any)=>{
      if(res){
        this.is_dealers_loader=false;
        this.dealers_list = res.dealer_list;
        this.is_dealers_loader = false;
        this.isDesplayBrandStore = true;
        // this._router.navigate([`dealer`], { queryParams: { page: this.page_number, mcId: this.activeMainCategoryId, cityId: this.city_id } })
      }
    },
    
    (err:any)=>{
      if(err){
        this.is_dealers_loader = false;
      }
    })
} 
onSelectDealer(dealer:any){
  this.dealer = dealer;
  this.isDesplayBrandStore = false;
  this.openCashback();
}
onCloseBrandStorePopup(){
  this.dealer = null;
  this.isDesplayBrandStore = false;
}

  openCashback(){
    this.displayCashbackDialog = true;
  }
  closeCashback(){
    this.dealer=null;
    this.professionl_phone = null;
    this.dealer = null;
    this.ref_by = null;
    this.invoice = null;
    if(this.router.url.includes('is_cashback')){
      this.router.navigate(
        [],
        {
          relativeTo: this._acRoute,
          queryParams: {is_cashback:null},
          queryParamsHandling: 'merge',
          replaceUrl:true
        });
    }
    this.displayCashbackDialog = false;
  }
  
  uploadInvoice(event: any) {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      this.file = files[0]; // Assign the first selected file to this.file
    }
    if (this.file.type == 'application/pdf') {
      this.file_type = 'pdf';
    } else {
      this.file_type = 'image';
      const reader = new FileReader(); // HTML5 FileReader API
      const file = event.target.files[0];
      if (event.target.files && event.target.files[0]) {
        reader.readAsDataURL(file);
  
        // When file uploads set it to file formcontrol
        reader.onload = () => {
          this.invoice_url = reader.result;
          this.registrationForm.patchValue({
            file: reader.result
          });
         
        }      
      }
    }
    this.invoice = this.file
    // this.uploadAndProgress()
  }
  onSubmit(){
    this.is_submit=true;
    if(!this._as.isUserLoggedIn){
      this._as.isDisplayLogin = true;
      return
    }
    if(!this.dealer){
      this.is_dealer_not_seleted = true;
      return
    }
    if(!this.invoice){
      this.is_invoice_receipt_not_upload = true;
      setTimeout(() => {
        this.is_invoice_receipt_not_upload = false;
      }, 2000);
      return
    }
    if(!this.professionl_phone){
      this.is_professional_not_seleted = true;
      return
    }
    
   this.createcashback();
  }
  createcashback() {
    this.is_uploading_progress = true
    const formData = new FormData();
    formData.append('invoice', this.invoice)
    // formData.append('payment_receipt', this._cashback.payment_receipt)
    formData.append('form_type', this.file_type)
    // formData.append('file_type_payment', this.file_type_payment)
    formData.append('dealer', this.dealer.id)
    // formData.append('ref_by', this._cashback.ref_by.id)
    formData.append('professional_mobile', this.professionl_phone)
    formData.append('project', this._project.selectedProject?.id)
    this.uploadSuccess = false;
    const url = this._as.api_base_url + 'user/cashback/';
    this._as.postRequest(url, formData, true).subscribe((event: any) => {
      if (event.type === HttpEventType.UploadProgress) {
        this.percentDone = Math.round(100 * event.loaded / event.total);
      } else if (event instanceof HttpResponse) {
        this.uploadSuccess = true;
      }
      this.dealer = null;
      this.ref_by = null;
      this.invoice = null;
      this.payment_receipt = null;
      // this.closeDisplayVisited()
      this.closeCashback();
      this.router.navigate(['cashback/detail/'+event.cashback])
      this.is_uploading_progress = false;
    },
      (err: any) => {
        if(err){
        this.is_uploading_progress = false
        }
      })
  }

  submitWithoutProd(){
    this.is_uploading_progress = true
    const formData = new FormData();
    formData.append('invoice', this.invoice)

    formData.append('form_type', this.file_type)
    formData.append('dealer', this.dealer.id)
    formData.append('project', this._project.selectedProject?.id)
    this.uploadSuccess = false;
    const url = this._as.api_base_url + 'user/cashback/';
    this._as.postRequest(url, formData, true).subscribe((event: any) => {
      if (event.type === HttpEventType.UploadProgress) {
        this.percentDone = Math.round(100 * event.loaded / event.total);
      } else if (event instanceof HttpResponse) {
        this.uploadSuccess = true;
      }
      this.dealer = null;
      this.ref_by = null;
      this.invoice = null;
      this.payment_receipt = null;
      // this.closeDisplayVisited()
      this.router.navigate(['cashback/detail/'+event.cashback])
      this.is_uploading_progress = false;
      this.closeCashback();
    },
      (err: any) => {
        if(err){
        this.is_uploading_progress = false
        }
      })
  }
}
